import React, { FC, useState, useCallback } from "react";
import useEventListener from "../../../hooks/useEventListener";
import ABCNavItem from "./ABCNavItem";
import ABCSection from "./ABCSection";
import { IABCToolProps } from "./ABCTool.interface";

const ABCTool: FC<IABCToolProps> = ({ navItems, sections }) => {
  /**
   * Create refs map (for scrolling navigation)
   *
   * This way we bind nav links selection with a
   * scrolling to correct section
   */
  const navListRefs = React.useRef({});

  const [activeItem, setActiveItem] = useState<string>(
    navItems && navItems[0]?.id,
  );

  /**
   * callback for children element to put itself into parent
   * map of refs
   */
  const pushToRefs = useCallback((element: HTMLElement, id: string) => {
    if (element) {
      navListRefs.current[id] = element;
    }
  }, []);

  /**
   * Scroll handler
   * Whenever user scrolls or touchmove a page
   * currently selected nav item becomes deselected
   */
  const handleScroll = () => {
    setActiveItem(null);
  };

  useEventListener("wheel", handleScroll);
  useEventListener("touchmove", handleScroll);

  /**
   * Nav items click handler
   *
   * Scrolls correspondent section into user's view
   */
  const handleSelectItem = useCallback((id) => {
    const targetElement = navListRefs.current[id];

    (targetElement as unknown as HTMLElement)?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
    setActiveItem(id);
  }, []);

  return (
    <>
      {/* Render nav list  */}
      <div className="abc-nav">
        <ul className="abc-nav__wrapper">
          {navItems?.map((item) => (
            <ABCNavItem
              id={item.id}
              key={item.id}
              active={activeItem === item.id}
              onSelect={handleSelectItem}
              {...item}
            />
          ))}
        </ul>
      </div>

      {/* Render section items list with refs */}
      {sections?.map((section) => (
        <ABCSection createRef={pushToRefs} key={section.id} {...section} />
      ))}
    </>
  );
};

export default ABCTool;
